import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { LegalDocument } from '@/features/legal/components/LegalDocument'
import {
  PRIVACY_TOC,
  PrivacyContent,
} from '@/features/legal/components/PrivacyContent'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/privacy')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/privacy']),
    links: generateLinks(routeSEO['/privacy']),
  }),
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Legal"
          title="Privacy policy"
          lede="Last updated: February 5, 2026"
        />
        <LegalDocument toc={PRIVACY_TOC}>
          <PrivacyContent />
        </LegalDocument>
      </main>

      <Footer />
    </div>
  )
}
